// extracted by mini-css-extract-plugin
export default {"recos":"B5-z","productCardOverride":"C5-z","rowHasBadge":"D5-z"};